type Props = {
  count: number
  width: number
  snapToInterval: number
  gap: number
}

const getScrollMax = ({ count, width, snapToInterval, gap }: Props) => {
  return count - Math.floor((width + gap) / (snapToInterval + gap))
}

export default getScrollMax
